import { TagParamDataLayer } from '@app-types/tracking';

import { create } from 'zustand';

type tagsStoreType = {
    currentPageTags: TagParamDataLayer | null;
    setCurrentPageTags: (pageTags: TagParamDataLayer) => void;
};
const TAGS_STORAGE_KEY = 'tags';

const saveTagstToLocalStorage = (pageTags: TagParamDataLayer | null) => {
    if (typeof window === 'undefined') {
        return;
    }
    if (pageTags) {
        localStorage.setItem(TAGS_STORAGE_KEY, JSON.stringify(pageTags));
    } else {
        localStorage.removeItem(TAGS_STORAGE_KEY);
    }
};

const getTagsFromLocalStorage = (): TagParamDataLayer | null => {
    if (typeof window === 'undefined') {
        return null;
    }
    const cartData = localStorage.getItem(TAGS_STORAGE_KEY);
    return cartData ? JSON.parse(cartData) : null;
};

export const tagsStore = create<tagsStoreType>((set) => ({
    currentPageTags: getTagsFromLocalStorage(),
    setCurrentPageTags: (pageTags: TagParamDataLayer) => {
        saveTagstToLocalStorage(pageTags);
        set(() => ({
            currentPageTags: pageTags,
        }));
    },
}));
